// Mobile scroll reset utility
export const initMobileScrollFix = () => {
  // Reset scroll behavior on load
  window.addEventListener("load", function() {
    document.body.style.overflowY = "auto";
    document.documentElement.style.overflowY = "auto";
    
    // Reset any problematic heights
    document.body.style.height = "auto";
    document.documentElement.style.height = "auto";
    
    // Ensure smooth scrolling
    document.documentElement.style.scrollBehavior = "smooth";
  });
  
  // Fix iOS Safari viewport height issues
  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
  
  setVh();
  window.addEventListener('resize', setVh);
  window.addEventListener('orientationchange', setVh);
};

// Call this function on app initialization
export default initMobileScrollFix;